const config = {
  // Base URLs for different environments
  development: {
    baseUrl: 'https://localhost:3001',
    resetPasswordUrl: 'https://localhost:3001/resetpassword'
  },
  production: {
    baseUrl: 'https://app.securepaper.app',
    resetPasswordUrl: 'https://app.securepaper.app/resetpassword'
  },
  
  // Get the current environment configuration
  get current() {
    const isDev = import.meta.env.DEV || process.env.NODE_ENV === 'development';
    return isDev ? this.development : this.production;
  },
  
  // Get the reset password URL for the current environment
  get resetPasswordUrl() {
    return this.current.resetPasswordUrl;
  }
};

export default config;
